import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type {
  UpdateReleaseStatusDTO,
  UpdateReleaseStatusResponse,
} from "./type";

export async function updateReleaseStatus(
  release: UpdateReleaseStatusDTO,
): Promise<UpdateReleaseStatusResponse> {
  const response = await apiClient.patch<UpdateReleaseStatusResponse>(
    apiPaths.releases.update(release.id),
    { status: release.status },
  );
  return response.data;
}
